// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"421":"32c58762","777":"d02b6773","991":"0353e2f4"}[chunkId] + ".chunk.css";
};